module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_clubs-king.c683441a.svg";